"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnStarException = void 0;
class UnStarException extends Error {
    constructor() {
        super("Error un-favourting message!");
        this.name = "UnStarException";
    }
}
exports.UnStarException = UnStarException;
